export enum NotificationMethod {
	default,
	email,
	whatsApp
}